import {
  GET_ADMIN_LEAD_PRICES,
  GET_ADMIN_LEAD_PRICES_SUCCESS,
  GET_ADMIN_LEAD_PRICES_ERROR,
  UPDATE_ADMIN_LEAD_PRICE,
  UPDATE_ADMIN_LEAD_PRICE_SUCCESS,
  UPDATE_ADMIN_LEAD_PRICE_ERROR
} from "./actionTypes"

export const getAdminLeadPrices = () => {
  return {
    type: GET_ADMIN_LEAD_PRICES,
  }
}

export const getAdminLeadPricesSuccess = (lead_prices) => {
  return {
    type: GET_ADMIN_LEAD_PRICES_SUCCESS,
    payload: lead_prices,
  }
}

export const getAdminLeadPricesError = (error) => {
  return {
    type: GET_ADMIN_LEAD_PRICES_ERROR,
    payload: error,
  }
}

export const updateAdminLeadPrice = (payload) => {
  return {
    type: UPDATE_ADMIN_LEAD_PRICE,
    payload: payload,
  }
}

export const updateAdminLeadPriceSuccess = (lead_prices) => {
  return {
    type: UPDATE_ADMIN_LEAD_PRICE_SUCCESS,
    payload: lead_prices,
  }
}

export const updateAdminLeadPriceError = (error) => {
  return {
    type: UPDATE_ADMIN_LEAD_PRICE_ERROR,
    payload: error,
  }
}

